import DialogConfirmar from 'global/guides/Dialog/DialogConfirmar'
import { usePagamentoHorasOutletContext } from 'pages/PagamentoHoras.context'
import { Navigate } from 'react-router-dom'
import { pagamentoHoras } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'

export default function PagarTudo() {
    const empresaId = useStore(state => state.companyId)
    const { competencia, selecionados } = usePagamentoHorasOutletContext()
    const { mutateAsync, isLoading } = pagamentoHoras.tudo.mutations.useCreate({
        queryParams: {
            empresaId,
            competencia,
        },
        onSuccess: () => {
            pagamentoHoras.invalidateQueries()
            toast.success('Pagamento realizado com sucesso')
        },
        onError: e => {
            toast.error(e.message)
        },
    })

    if (!selecionados?.length)
        return <Navigate to="/manutencao-ponto/pagamento-horas" />

    const handleSubmit = () => {
        return mutateAsync(selecionados as number[])
    }

    return (
        <DialogConfirmar
            permissao={['update', 'PagamentoDeHoras']}
            loading={isLoading}
            onConfirm={handleSubmit}
            title={`Pagar ${selecionados?.length} funcionário(s)`}
        >
            Tem certeza que deseja pagar todas as horas extras e descontar as
            faltas dos funcionários selecionados?
        </DialogConfirmar>
    )
}
